import { useCallback, useMemo } from 'react'

import { useAppSelector } from '@user/store/hooks'
import { selectAllLeadOppProducts } from '@user/store/leadOppProducts'
import { selectAllServiceLocations } from '@user/store/entityLocations'

import {
  useSchedulingWizard,
  toFiltersActionCreator as toFilters,
} from '../wizardContext'
import { locAndSvcInitValues, type LocAndSvcsFormModel } from './formConfig'

export function useData() {
  const serviceLocationsAll = useAppSelector(selectAllServiceLocations)

  const serviceLocations = useMemo(
    () =>
      serviceLocationsAll.filter((x) => !x.billingLocation && x.isSchedulable),
    [serviceLocationsAll],
  )

  const services = useAppSelector(selectAllLeadOppProducts)

  const [{ canClose, entityType }, dispatch] = useSchedulingWizard()

  const onSubmit = useCallback(
    async (values: LocAndSvcsFormModel) =>
      dispatch(toFilters(values, serviceLocations, services)),
    [dispatch, serviceLocations, services],
  )

  const initialValues = useMemo<LocAndSvcsFormModel>(
    () => ({
      ...locAndSvcInitValues,
      closeWin: canClose ? 'close' : 'open',
      serviceLocationId: `${serviceLocations[0]?.id ?? ''}`,
    }),
    [canClose, serviceLocations],
  )

  return {
    onSubmit,
    services,
    initialValues,
    serviceLocations,
    entityType,
  }
}
